import { Component } from '@angular/core';
import {AppMainComponent} from './app.main.component';

@Component({
  selector: 'app-footer',
  templateUrl: './app.footer.component.html',
  styles:[`
  .footer .box-container {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (minmax(25rem, 1fr))[auto-fit];
        grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
    gap: 1.5rem;
  }
  
  .footer .box-container .box {
    padding: 1rem 0;
  }
  
  .footer .box-container .box .logo {
    padding-bottom: 1rem;
  }
  
  .footer .box-container .box h3 {
    font-size: 2.2rem;
    color: #fff;
    padding: 1rem 0;
  }
  
  .footer .box-container .box p {
    font-size: 1.2rem;
    color: #aaa;
    padding: 1rem 0;
    line-height: 2;
  }
  
  .footer .box-container .box p i {
    padding-right: .5rem;
    color: #29d9d5;
  }
  
  .footer .box-container .box .share {
    padding-top: 1rem;
  }
  
  .footer .box-container .box .share a {
    height: 4.5rem;
    width: 4.5rem;
    line-height: 4rem;
    font-size: 2rem;
    border-radius: 50%;
    font-size: 1.2rem;
    border: 0.2rem solid #29d9d5;
    color: #7bb7f9;
    margin-right: .5rem;
    text-align: center;
  }
  
  .footer .box-container .box .share a:hover {
    background: #232323;
    color: #111;
  }
  
  .footer .box-container .box .links {
    font-size: 1.2rem;
    color: #aaa;
    padding: 1rem 0;
    display: block;
  }
  
  .footer .box-container .box .links:hover {
    color: #29d9d5;
  }
  
  .footer .box-container .box .links:hover i {
    padding-right: 2rem;
  }
  
  .footer .box-container .box .links i {
    padding-right: .5rem;
    color: #29d9d5;
  }
  
  .footer .box-container .box form .email {
    width: 100%;
    border-radius: 5rem;
    border: 0.2rem solid #29d9d5;
    background: #232323;
    font-size: 1.2rem;
    text-transform: none;
    color: #aaa;
    margin-bottom: 1rem;
    padding: 1.2rem 1.4rem;
  }

  .credit {
    background: #222;
    text-align: center;
    font-size: 1.2rem;
    padding: 1rem 1rem;
    color: #aaa;
  }
  
  .credit span {
    color: #29d9d5;
  }

  .logo-sfdc {
    display: block;
    margin: 0 auto;
    width: 100%;
    max-width: 430px;
    height: 100%;
    padding: 26.6666666667px 0;
    text-align: center;
    background: #232323;
    background-size: 100% 1px;
    background-repeat: no-repeat;
}
article, aside, details, figcaption, figure, footer, header, hgroup, main, nav, section, summary {
    display: block;
}

.logo-sfdc a {
  display: block;
  color: #dcdae9;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: .05em;
  font-size: 10px;
  font-weight: bold;
}

.logo-sfdc a span {
  display: inline-block;
  height: 49px;
  width: 70px;
  text-align: center;
  margin: 0 3px -22px;
  overflow: hidden;
  text-indent: 101%;
  white-space: nowrap;
  //background: url(https://id.heroku.com/assets/logo-sfdc.png);
  background-repeat: repeat;
  background-repeat: no-repeat;
}

.legal {
  list-style: none;
  margin-top: 10px;
  padding: 0;
  text-align: center;
}

.legal li, .legal a {
  font-size: 14px;
  font-weight: bold;
  text-transform: none;
  letter-spacing: 0;
  color: #dcdae9;
}

.legal li {
  display: inline-block;
  margin: 5px;
}

.legal li, .legal a {
  font-size: 12px;
  font-weight: bold;
  text-transform: none;
  letter-spacing: 0;
  color: #dcdae9;
}
.logo-sfdc a {
  display: block;
  color: #dcdae9;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: .05em;
  font-size: 10px;
  font-weight: bold;
}

  @media (max-width: 991px) {
    html {
      font-size: 55%;
    }
    .header {
      padding: 1.5rem 2rem;
    }
    section {
      padding: 3rem 2rem;
    }
  }
  `]
})
export class AppFooterComponent {
  constructor(public app: AppMainComponent) {}
}
